/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-webapp API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.51
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewsletterContent
 */
export interface NewsletterContent {
    /**
     * 
     * @type {string}
     * @memberof NewsletterContent
     */
    nlId: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterContent
     */
    content: string;
}

/**
 * Check if a given object implements the NewsletterContent interface.
 */
export function instanceOfNewsletterContent(value: object): value is NewsletterContent {
    if (!('nlId' in value) || value['nlId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function NewsletterContentFromJSON(json: any): NewsletterContent {
    return NewsletterContentFromJSONTyped(json, false);
}

export function NewsletterContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewsletterContent {
    if (json == null) {
        return json;
    }
    return {
        
        'nlId': json['nlId'],
        'content': json['content'],
    };
}

export function NewsletterContentToJSON(value?: NewsletterContent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nlId': value['nlId'],
        'content': value['content'],
    };
}

